var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIntegration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "integration"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.1667 13.3332L10.8333 9.99987V7.34987C11.9583 6.94153 12.7167 5.77487 12.4417 4.46653C12.2333 3.4832 11.4167 2.69987 10.425 2.5332C8.85833 2.27487 7.5 3.47487 7.5 4.99987C7.5 6.0832 8.2 6.99987 9.16667 7.34987V9.99987L5.83333 13.3332H3.33333C2.875 13.3332 2.5 13.7082 2.5 14.1665V16.6665C2.5 17.1249 2.875 17.4999 3.33333 17.4999H5.83333C6.29167 17.4999 6.66667 17.1249 6.66667 16.6665V14.9582L10 11.4582L13.3333 14.9582V16.6665C13.3333 17.1249 13.7083 17.4999 14.1667 17.4999H16.6667C17.125 17.4999 17.5 17.1249 17.5 16.6665V14.1665C17.5 13.7082 17.125 13.3332 16.6667 13.3332H14.1667Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegration);
export default __webpack_public_path__ + "static/media/integration.d2f26397ce6bf36ca24c4340c8803416.svg";
export { ForwardRef as ReactComponent };